export const CONFIRMED_GET_NOTE_CATEGORIES = "CONFIRMED_GET_NOTE_CATEGORIES";
export const CONFIRMED_CREATE_NOTE_CATEGORIES = "CONFIRMED_CREATE_NOTE_CATEGORIES";
export const CONFIRMED_DELETE_NOTE_CATEGORIES = "CONFIRMED_DELETE_NOTE_CATEGORIES";
export const CONFIRMED_EDIT_NOTE_CATEGORIES = "CONFIRMED_EDIT_NOTE_CATEGORIES";
